import { useSearchParams } from 'react-router-dom';
import classnames from 'classnames';

export default function DictionaryAlphabetFilter({
  alphabet,
  activeKey,
}: {
  alphabet: string[];
  activeKey: string | string[] | undefined;
}) {
  const [searchParams, setSearchParams] = useSearchParams();

  const onClickFn = (indexKey: string) => {
    setSearchParams({ indexKey });
  };
  const keyList = ['ALL'].concat(alphabet);
  return (
    <div className='tw-flex tw-justify-center tw-items-center tw-mb-3'>
      <ol className='tw-flex tw-justify-center tw-items-center tw-flex-wrap tw-max-w-2xl'>
        {keyList.map((char, idx) => {
          const textCls = classnames(
            'tw-uppercase tw-underline tw-px-2 eds-type--title-4 hover:tw-opacity-100 hover:tw-cursor-pointer',
            {
              'tw-opacity-100': activeKey === char,
              'tw-opacity-60': activeKey !== char,
            },
          );
          return (
            <li key={char} onClick={() => onClickFn(char)} className={textCls}>
              {char}
            </li>
          );
        })}
      </ol>
    </div>
  );
}
